import { type ReactNode } from "react";
import { Topbar } from "./Topbar";
import { BreadcrumbsProvider } from "./BreadcrumbsContext";

interface ShellProps {
  children: ReactNode;
  rightRail?: ReactNode | null;
}

export function Shell({ children, rightRail = null }: ShellProps) {
  return (
    <BreadcrumbsProvider>
      <div className="app" data-has-rail={rightRail ? "true" : "false"}>
        <Topbar />
        <div className="main">
          <div className="page">{children}</div>
        </div>
        {rightRail ? <aside className="right-rail">{rightRail}</aside> : null}
      </div>
    </BreadcrumbsProvider>
  );
}
